export { TextInAColouredPanel as default } from "@ecologi/react-components/src/TextInAColouredPanel";
